import axios from 'axios';
import Vue from 'vue';


const state = { status: '', articles: [], article: {}, error: {} };

const getters = {
  getArticles: state => state.articles,
  getArticle: state => state.article,
  getError: state => state.error,
 // getActivityById: state => id => state.activities.find(activity => activity.id === id),
};

const actions = {
  articlesRequest({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
    axios({ url: `${process.env.VUE_APP_ROOT_API}/articles/` })
      .then(resp => {
        const articles = resp.data;
        commit('setArticles', articles);
      })
      .catch(error => {
        reject(error);
       })
      })
  },
  articleRequest({ commit, dispatch }, article_id) {
    return new Promise((resolve, reject) => {
    axios({ url: `${process.env.VUE_APP_ROOT_API}/articles/${article_id}` })
      .then(resp => {
        const article = resp.data;
        commit('setArticle', article);
      })
      .catch(error => {
        reject(error);
       })
      })
  },
 /* updateActivity({commit, dispatch}, activity) {
    return new Promise((resolve, reject) => {
      axios({url: `${process.env.VUE_APP_ROOT_API}/activities/${activity.activity_id}/track/`, data: activity, method: 'POST'})
      .then(resp => {

        commit('setActivity', resp);
        resolve(resp);
      })
      .catch(error => {
        const err = error.response.data;
        commit('setError', err);
        reject(error)
      })
    })
  },
  activityRequest({ commit, dispatch }, activity_id) {
    return new Promise((resolve, reject) => {
    axios({ url: `${process.env.VUE_APP_ROOT_API}/activities/${activity_id.act_id}/` })
      .then(resp => {
        commit('setActivity', resp.data);
      })
      .catch(error => {
        reject(error);
       })
      })
  },*/
};

const mutations = {
  setArticles(state, articles) {
    state.status = 'success';
    state.articles = articles;
  },
  setArticle(state, article) {
    state.status = 'success';
    state.article = article;
  },
  setError(state, error) {
    state.status = 'error';
    state.error = error;
  },
};

const namespaced = true;
export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
